import React from 'react';
import Tags from '../../../element/tag';
import Title from '../../../element/title';
import clone from 'clone';
import url from '../../../urlhandler/urlHandlerActions';

const $ = jQuery;
const RE = REBUILDER;

class TagsPreview extends React.Component {
  constructor(props) {
    super(props);
    this.handleTagValue = this.handleTagValue.bind(this);
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;

    this.state = {
      'values': [],
      'options': [],
      'toogle': false,
    };
    this.changeToogle = this.changeToogle.bind(this);
  }

  componentWillMount() {
    const block = clone(this.props.block);
    this.processData(block);
  }
  componentWillReceiveProps(nextprops) {
    const block = clone(nextprops.block);
    this.setState({ toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
    this.processData(block);
  }
  processData(block) {
    this.helperData = clone(this.props.helperData);
    this.block = block;
    let options = [];
    let values = [];
    if (this.block.selectedDataType !== null) {
      // taxonomies
      if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
        options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
        this.searchType = 'taxonomies';
        this.searchItem = this.block.selectedTaxonomy;
        // url case
        for (let indexOfArray = 0; indexOfArray < window.searchArray.length; indexOfArray++ ) {
          if (window.searchArray[indexOfArray].key === this.searchItem) {
            values.push(window.searchArray[indexOfArray].value);
          }
        }
        // if (this.props.urlData.hasOwnProperty(this.searchItem)) {
        //   // if (this.state.values.length < 1) {
        //   values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
        //   // }
        // } else {
        //   values = [];
        // }
      }
    }
    options.map((item) => {
      item.isActive = false;
      if (this.block.selectedType !== undefined) {
        if (this.block.selectedType.value === 'singleselect' && item.slug === values[0]) {
          item.isActive = true;
        }
      } else if (item.slug === values[0]) {
        item.isActive = true;
      }
    });
    if (this.block.selectedType !== undefined) {
      if (this.block.selectedType.value === 'multiselect') {
        options.map((item) => {
          if (values.indexOf(item.slug) !== -1) {
            item.isActive = true;
          }
        });
      }
    }
    this.setState({
      values, options,
    });
  }
  handleTagValue(e, tagItem) {
    e.preventDefault();
    const options = this.state.options;
    const values = [];
    if (this.props.block.selectedType !== undefined) {
      if (this.props.block.selectedType.value === 'singleselect') {
        options.map((item) => {
          if (item.slug === tagItem.slug) {
            item.isActive = !item.isActive;
          } else {
            item.isActive = false;
          }
          if (item.isActive) values.push(item);
        });
      } else {
        options.map((item) => {
          if (item.slug === tagItem.slug) {
            item.isActive = !item.isActive;
          }
          if (item.isActive) values.push(item);
        });
      }
    }
    this.setState({ 'values': _.pluck(values, 'slug') });
    url.push({
      'searchItem': this.searchItem,
      'searchType': this.searchType,
      'searchField': 'tags',
      values,
    });
  }
  changeToogle() {
    const toogle = !this.state.toogle;
    this.setState({ toogle });
  }
  render() {
    const ifOpen = this.state.toogle ? 'active' : 'toggle-option';
    const HelperClass = this.state.toogle ? 'single-component' : '';
    return (<div>
      <Title
        title={this.props.block.title}
        subtitle={this.props.block.subtitle}
        toogle= {this.state.toogle}
        onToogle = {this.changeToogle}
        selectedToogleViewType = {'true'}
        dropdown = {true}
        field={this.props.block.uid}
      />
      <div className={HelperClass + ' ' + 'dropdown-template'}>
      {this.state.options !== undefined && this.state.options.length ?
        <div>
          <Tags options={this.state.options} isOpenElement={ifOpen} onSelectTags={this.handleTagValue} />
        </div> : null}
      {this.state.options.length === 0 && this.state.toogle ?
        <div className={'rq-no-attributes-found' + ' ' + ifOpen}>
          <h3>{API.LANG.NO_ATTR_FOUND}</h3>
        </div> : ''}
      </div>
    </div>);
  }
}

TagsPreview.propTypes = {
  'urlData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'helperData': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
};

export default TagsPreview;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/search/dropdown/tagsdropdownpreview.js
 **/